const data = [
  {
    name: 'John Clarke',
    title: 'Great service! Highly recommend',
    body:
      'Great service, friendly and hardworking. Did a great job for us and I would highly recommend this service for moving home. Very good.',
    url: 'https://uk.trustpilot.com/reviews/5dc3fcbe604858093c23def9',
  },
  {
    name: 'Chris Didlick',
    title: 'Polite, Professional and Friendly.',
    body:
      'Kareem provided removals services for myself and my girlfriend from two different locations. He was polite, professional and friendly. There was an initial traffic delay but Kareem kept us informed at all times. One of the addresses was situated in a difficult location but he worked around it and the removals went without a hitch. Kareem was helped by his assistant Razaq who was diligent and hard-working. We were also given a very good price considering pick-up from two properties. I would recommend Kareem to anyone looking for removals services!',
    url: 'https://uk.trustpilot.com/reviews/5a7d90ddd27b0a0520708f15',
  },
  {
    name: 'Jay Alam',
    title: 'He was very helpful',
    body:
      'He was very helpful, couldn\'t ask for a better person even if I tried, he went over and beyond with his service. Thank you',
    url: 'https://uk.trustpilot.com/reviews/5dc3fcbe604858093c23def9',
  },
];

export default data;
